import React from 'react';
import imageSrc from '../../assets/images/slide/product-book-preview-tablet.png';
import styles from './ProductSlideContentV16.css';

function ProductSlideContentV16() {
    return (
        <section className={styles.form}>
            <p className={styles.label}>Your digital book preview</p>
            <h2 className={styles.heading}>You’ve lived a story worth telling</h2>
            <img src={imageSrc} alt='' className={styles.image} />
            <h3 className={styles.subheading}>About your digital book</h3>
            <div className={styles.description}>
                <p>This is your story, in one place: childhood and school, first jobs, first love, family, and everything that came after.</p>
                <p>It starts small: a street you knew by sound, a kitchen, rules nobody ever explained.</p>
                <p>Chapters grow one question at a time. Who reads them, and when, is up to you. Open it anytime on your phone, tablet, or computer.</p>
            </div>
        </section>
    );
}

export {
    ProductSlideContentV16
};
